import React from 'react'
import DefaultBanner from './DefaultBanner'
import EndBanner from './EndBanner'
import { Route, Switch } from 'react-router-dom'
import ROUTES from '../../routes'

const MainBanner = () => {
  return (
    <Switch>
      <Route exact path={ROUTES.orderEnd}>
        <EndBanner />
      </Route>
      <Route>
        <DefaultBanner />
      </Route>
    </Switch>
  )
}

export default MainBanner
